// === OS2P · Dynamic Checkout (unbranded) — igual al ATC en forma/medidas, negro en color ===
(function () {
  // Colores que quieres mantener siempre
  var FORCE = {
    backgroundColor: '#000000',
    color: '#ffffff',
    borderColor: '#000000'
  };

  // Propiedades que clonamos del botón "Añadir al carrito" (ATC)
  var CLONE_KEYS = [
    // caja/forma
    'borderRadius','borderTopLeftRadius','borderTopRightRadius','borderBottomRightRadius','borderBottomLeftRadius',
    'borderStyle','borderWidth',
    'paddingTop','paddingRight','paddingBottom','paddingLeft',
    'minHeight','lineHeight',

    // tipografía
    'fontFamily','fontSize','fontWeight','fontStyle','letterSpacing','textTransform','textDecoration','textAlign',

    // layout
    'boxSizing'
  ];

  // Utilidad: aplica estilos de objeto
  function applyStyles(el, obj) {
    Object.keys(obj).forEach(function (k) {
      el.style[k] = obj[k];
    });
  }

  // Obtiene el botón ATC “real” más cercano
  function getATC(el) {
    var form = el.closest('form') || document.querySelector('form[action*="/cart/add"]');
    return (form && (
      form.querySelector('[type="submit"]') ||
      form.querySelector('.button') ||
      form.querySelector('.btn')
    )) || document.querySelector('.product-form [type="submit"], .product-form .button, .product-form .btn');
  }

  // Clona estilo visual del ATC (excepto color), y fuerza negro/blanco
  function syncLikeATC(payBtn) {
    if (!payBtn) return;

    var atc = getATC(payBtn);
    if (!atc) return;

    var cs = getComputedStyle(atc);

    // 1) Clonar propiedades del ATC
    var clone = {};
    CLONE_KEYS.forEach(function (k) { clone[k] = cs[k]; });

    // Asegurar centrado y display consistente
    clone.display = 'flex';
    clone.alignItems = 'center';
    clone.justifyContent = 'center';
    clone.width = '100%';
    clone.boxShadow = 'none';       // evitamos glow
    clone.outline = 'none';         // evitamos aros
    clone.filter = 'none';
    clone.backgroundImage = 'none';
    clone.transition = 'none';
    // Si el ATC usa height fija, NO la copiamos; preferimos min-height + paddings

    // 2) Aplicar clon y forzar los colores
    applyStyles(payBtn, clone);
    payBtn.style.backgroundColor = FORCE.backgroundColor;
    payBtn.style.color = FORCE.color;
    payBtn.style.borderColor = FORCE.borderColor;

    // 3) Estados deben lucir IGUAL
    ['mouseenter','mouseleave','mousedown','mouseup','focus','blur'].forEach(function (evt) {
      payBtn.addEventListener(evt, function () {
        applyStyles(payBtn, {
          backgroundColor: FORCE.backgroundColor,
          color: FORCE.color,
          borderColor: FORCE.borderColor,
          boxShadow: 'none',
          outline: 'none',
          filter: 'none',
          backgroundImage: 'none',
          transition: 'none',
          transform: 'none'
        });
      }, { passive: true });
    });

    // 4) Spans internos centrados (algunos temas anidan texto)
    payBtn.querySelectorAll('span, span span').forEach(function (s) {
      s.style.display = 'flex';
      s.style.alignItems = 'center';
      s.style.justifyContent = 'center';
      s.style.width = '100%';
    });

    // Marcar pintado
    payBtn.dataset.os2pPainted = '1';
  }

  // Escanea y sincroniza todos los unbranded
  function scan(ctx) {
    (ctx || document).querySelectorAll('.shopify-payment-button__button--unbranded').forEach(function (btn) {
      // Siempre re-sincroniza (por si cambió el preset/ATC en responsive)
      syncLikeATC(btn);
    });
  }

  // Debounce sencillo
  var tick;
  function debounceScan() {
    clearTimeout(tick);
    tick = setTimeout(function(){ scan(document); }, 50);
  }

  // Boot + observar re-render de Shopify/tema + responsive
  document.addEventListener('DOMContentLoaded', function () {
    scan(document);

    var mo = new MutationObserver(function (muts) {
      for (var i=0;i<muts.length;i++) {
        var m = muts[i];
        if (m.addedNodes && m.addedNodes.length) { debounceScan(); break; }
      }
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });

    window.addEventListener('resize', debounceScan, { passive: true });
  });
})();
